import {ReactNode, useState} from "react";
import {Box, ButtonBase, Typography} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

// a folding section of a sidebar: a header row (chevron, optional icon, title, optional
// trailing badge) that opens or closes the body under it.
export function SidebarSection(props: {
    title: string;
    icon?: ReactNode;
    badge?: ReactNode;
    defaultExpanded?: boolean;
    children: ReactNode;
}) {
    const [expanded, setExpanded] = useState(!!props.defaultExpanded);

    return (
        <Box sx={{borderBottom: 1, borderColor: "divider"}}>
            <ButtonBase
                onClick={() => setExpanded(!expanded)}
                sx={{
                    display: "flex",
                    width: "100%",
                    alignItems: "center",
                    gap: 0.5,
                    px: 0.5,
                    py: 0.5,
                    textAlign: "left",
                    "&:hover": {bgcolor: "action.hover"},
                }}
            >
                {expanded ? <ExpandMoreIcon sx={{fontSize: 18}} /> : <ChevronRightIcon sx={{fontSize: 18}} />}
                {props.icon}
                <Typography variant="subtitle2" sx={{flex: 1}}>{props.title}</Typography>
                {props.badge}
            </ButtonBase>

            {expanded && props.children}
        </Box>
    );
}
